import React from 'react';
import CheckBox from './CheckBox.jsx';

export default function CheckBoxSelector(props) {
  const id = props.id || 'input-' + props.name;
  const label = props.label || props.name;
  const options = props.options || [];
  const value = props.value || [];
  const onChange = function (e) {
    const selectedOptions = [...value];
    const index = value.indexOf(e.target.value);
    if (index < 0) selectedOptions.push(e.target.value);
    else selectedOptions.splice(index, 1);
    if (props.onChange) {
      props.onChange({name: props.name, value: selectedOptions});
    } else console.log(props.name, selectedOptions);
  };
  let formGroupClassName = 'form-group';
  if (props.error) formGroupClassName += ' has-error';
  const optionBoxStyle = {
    maxHeight: props.maxHeight || '200px',
    overflowY: 'scroll',
    padding: '0px 10px',
    marginBottom: 0,
    backgroundColor: props.backgroundColor || '#fff',
  };
  if (props.noScroll) {
    delete optionBoxStyle.maxHeight;
    delete optionBoxStyle.overflowY;
  }
  const optionTags = options.map((option, key) => {
    const checkBoxProps = {
      label: option.name,
      name: props.name,
      value: option.value,
      checked: (value.indexOf(option.value) > -1),
      onChange,
      key
    }
    return (<CheckBox {...checkBoxProps} />);
  });
  return (
    <div className={formGroupClassName}>
      { label !== null && label !== undefined ? <label>{label}</label> : null }
      <div id={id} className="well" style={optionBoxStyle}>{optionTags}</div>
      <span className="help-block">{props.error || props.message}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/CheckBoxSelector.jsx